import { MdOutlineClear } from 'react-icons/md';
import { Button } from '@ds';
import { WorkdaySyncData } from '@lp/features/Scheduler/types';
import { FilterOptionsDropdown, SchedulerResourcesFilter } from '@lp/features/Scheduler/components';
import { scheduleFiltersSelectors, useCCSchedulerFiltersStore } from '@lp/core/store/scheduler';
import { CCResourcesWithShifts } from '@/api/apis/resources/schedule';

type CCSchedulerFiltersSectionProps = {
  readonly?: boolean;
  shiftsData: CCResourcesWithShifts;
  workdayData?: WorkdaySyncData;
};

export const CCSchedulerFiltersSection = ({ readonly, shiftsData, workdayData }: CCSchedulerFiltersSectionProps) => {
  const hasActiveFilters = useCCSchedulerFiltersStore(scheduleFiltersSelectors.hasActiveFilters);
  const filters = useCCSchedulerFiltersStore();

  return (
    <div className="flex items-center gap-4">
      {hasActiveFilters && (
        <Button disableRipple size="sm" variant="light" endContent={<MdOutlineClear />} onClick={filters.clearFilters}>
          Clear all
        </Button>
      )}
      <SchedulerResourcesFilter
        shiftsData={shiftsData}
        selectedKeys={filters.resources}
        onSelectedKeysChange={(ids) => filters.setFilterByKey('resources', ids)}
      />
      <FilterOptionsDropdown
        onlyStatusFilter={readonly}
        withShiftTotals
        shiftTotalsEnabled={filters.shiftTotals}
        onShiftTotalsChange={(enable) => filters.setFilterByKey('shiftTotals', enable)}
        statusFilterEnabled={filters.statusFilters}
        onStatusFilterChange={(enable) => filters.setFilterByKey('statusFilters', enable)}
        workdayData={workdayData}
      />
    </div>
  );
};
